<template>
  <VaccinationPage
    title="Lung Disease"
    :buttons="buttons"
    baseRoute="/LungDiseaseSecondPage"
    :bottomImage="require('@/assets/page20/Asset 186.png')"
    :footerBanner="require('@/assets/page4/lowererPanner.png')"
    prevRoute="/vaccination"
    nextRoute="/vaccination"
  />
</template>

<script setup>
import VaccinationPage from "@/components/VaccinationPage.vue";

const buttons = [
  { imgPath: require("@/assets/page20/Asset 173.png"), name: "Influenza" },
  { imgPath: require("@/assets/page20/Asset 174.png"), name: "Pneumococcal" },
  { imgPath: require("@/assets/page20/Asset 175.png"), name: "RSV" },
  { imgPath: require("@/assets/page20/Asset 176.png"), name: "COVID-19" },
  { imgPath: require("@/assets/page20/Asset 177.png"), name: "HepatitisA" },
  { imgPath: require("@/assets/page20/Asset 178.png"), name: "HepatitisB" },
  { imgPath: require("@/assets/page20/Asset 179.png"), name: "Zoster" },
  { imgPath: require("@/assets/page20/Asset 180.png"), name: "MMR" },
  { imgPath: require("@/assets/page20/Asset 181.png"), name: "Varicella" },
  { imgPath: require("@/assets/page20/Asset 182.png"), name: "Tetanus" },
  { imgPath: require("@/assets/page20/Asset 183.png"), name: "MeningococcalMenB" },
  { imgPath: require("@/assets/page20/Asset 184.png"), name: "Humanpapilloma" },
];
</script>
